import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getCalendarsHolidays() {
      return getState().calendarsHolidays;
    },
    isRetrieveCalendarsHolidaysFailure() {
      return getState().request.isFailure;
    },
    isRetrieveCalendarsHolidaysPending() {
      return getState().request.isPending;
    },
    isRetrieveCalendarsHolidaysSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
